import './App.css';
import Home from './Home';
import HomeCard from './HomeCard';
import UserHeader from './UserHeader';
import { useNavigate } from 'react-router-dom';

function Header() {
    const navigate = useNavigate();
    // test

    return (
        <div>
            <div
                className='menu-bar'
                style={{paddingLeft: '45%'}}
            >
                <HomeCard
                    title="What's New"
                    icon='pi pi-clock'
                    link='/feed/'
                />
                {/* <HomeCard
                    title='Campaigns'
                    icon='pi pi-th-large'
                    link='/campaigns/'
                />
                <HomeCard
                    title='Devices'
                    icon='pi pi-tablet'
                    link='/devices/'
                /> */}
                <HomeCard
                    title='Marketplace'
                    icon='pi pi-th-large'
                    link='/marketplace/'
                />
                {/* <HomeCard
                    title='Test our AI'
                    icon='pi pi-prime'
                    link='/ai/test/'
                /> */}
                <div
                    style={{
                        marginLeft: 'auto',
                        paddingRight: '2em',
                    }}
                    onClick={() => navigate('/account')}
                >
                    <UserHeader user_id={localStorage.getItem('user_id')} />
                </div>
            </div>
        </div>
    )
}

export default Header;